import React from 'react';
import { STEPS } from '../data/content';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
export function Steps() {
  return <section id="como-funciona" className="border-y border-line bg-white py-20 sm:py-24" data-id="element-182" data-mp="18g7g022a1i33">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-8" data-id="element-183" data-mp="umg78vwde28f">
        <Reveal className="mx-auto max-w-2xl text-center" data-id="element-184" data-mp="yni6hcqaeeae">
          <p className="text-[11px] font-semibold uppercase tracking-overline text-brand-600" data-id="element-185" data-mp="ylxdhrjmf3en">
            Cómo funciona
          </p>
          <h2 className="mt-4 text-[2rem] font-semibold leading-[1.1] tracking-[-0.02em] text-ink-900 sm:text-[2.6rem]" data-id="element-186" data-mp="pnvgdn30cuwn">
            Comienza en 3 pasos
          </h2>
        </Reveal>

        <ol className="relative mx-auto mt-14 grid max-w-5xl gap-10 lg:grid-cols-3 lg:gap-8" data-id="element-187" data-mp="fp60fzuo9kj1">
          <span aria-hidden="true" className="absolute left-7 top-7 hidden h-px w-[calc(100%-3.5rem)] bg-gradient-to-r from-brand-200 via-brand-200 to-transparent lg:block" data-id="element-188" data-mp="2624u7n9mj198" />
          {STEPS.map((step, i) => <Reveal key={step.number} delay={i * 0.07} className="h-full" data-id="element-189" data-mp="1q9rc036rl68o" data-mpi={i}>
              <li className="relative flex h-full flex-col" data-id="element-190" data-mp="1lb7po1o9dsfs">
                <span className="grid h-14 w-14 place-items-center rounded-2xl bg-brand-600 text-[15px] font-semibold text-white shadow-cta ring-8 ring-white" data-id="element-191" data-mp="2015i4tt814as">
                  {step.number}
                </span>
                <h3 className="mt-6 text-[18px] font-semibold tracking-[-0.01em] text-ink-900" data-id="element-192" data-mp="17c84j3zyfvod">
                  {step.title.charAt(0) + step.title.slice(1).toLowerCase()}
                </h3>
                <p className="mt-3 max-w-sm text-[14.5px] leading-relaxed text-ink-500" data-id="element-193" data-mp="1hae3bcqgslp0">
                  {step.description}
                </p>
              </li>
            </Reveal>)}
        </ol>

        <Reveal delay={0.1} data-id="element-194" data-mp="2spb39ho6svb5">
          <div className="mt-14 text-center" data-id="element-195" data-mp="2soht06q0rno9">
            <CTAButton label="Crear mi cuenta" location="steps" size="lg" data-id="element-196" data-mp="2nqq4lmol2jot" />
          </div>
        </Reveal>
      </div>
    </section>;
}